if (!customElements.get('photo-testimonials-cards')) {
  customElements.define(
    'photo-testimonials-cards',
    class PhotoTestimonialsCards extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-photo-testimonials-scroller]');
        this.track = this.querySelector('[data-photo-testimonials-track]');
        this.initialIndex = Number(this.getAttribute('data-initial-index')) || 0;
        this.mobileQuery = window.matchMedia('(max-width: 767px)');
        this.isResetting = false;
        this.hasAlignedInitialCard = false;

        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

        this.setup();
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('load', this.handleResize, { once: true });
        this.mobileQuery.addEventListener('change', this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('load', this.handleResize);
        this.mobileQuery.removeEventListener('change', this.handleResize);
        this.scroller?.removeEventListener('scroll', this.handleScroll);
      }

      handleResize() {
        this.hasAlignedInitialCard = false;
        this.setup();
      }

      setup() {
        this.scroller?.removeEventListener('scroll', this.handleScroll);

        if (!this.scroller || !this.track || !this.mobileQuery.matches) {
          return;
        }

        this.cards = this.track.querySelectorAll('.photo-testimonials-cards__card');
        this.blockCount = this.cards.length / 3;

        if (this.blockCount < 1) {
          return;
        }

        this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
        this.alignInitialCard();
        window.setTimeout(() => this.alignInitialCard(), 250);
      }

      getSetWidth() {
        if (!this.cards?.length || this.blockCount < 1) {
          return 0;
        }

        const firstCard = this.cards[0];
        const nextSetCard = this.cards[this.blockCount];

        if (!firstCard || !nextSetCard) {
          return 0;
        }

        return nextSetCard.offsetLeft - firstCard.offsetLeft;
      }

      alignInitialCard() {
        if (!this.scroller || !this.cards?.length || !this.mobileQuery.matches || this.hasAlignedInitialCard) {
          return;
        }

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const setWidth = this.getSetWidth();

            if (!setWidth) {
              return;
            }

            const targetIndex = Math.min(Math.max(this.initialIndex, 0), this.blockCount - 1);
            const target = this.cards[this.blockCount + targetIndex];

            if (!target) {
              return;
            }

            this.isResetting = true;
            this.scroller.scrollLeft = setWidth;

            const scrollerRect = this.scroller.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();
            const scrollLeft =
              this.scroller.scrollLeft +
              targetRect.left -
              scrollerRect.left -
              (this.scroller.clientWidth - targetRect.width) / 2;

            this.scroller.scrollTo({
              left: scrollLeft,
              behavior: 'auto',
            });

            this.isResetting = false;
            this.hasAlignedInitialCard = true;
          });
        });
      }

      handleScroll() {
        if (this.isResetting || !this.mobileQuery.matches) {
          return;
        }

        const setWidth = this.getSetWidth();

        if (!setWidth) {
          return;
        }

        const scrollLeft = this.scroller.scrollLeft;

        if (scrollLeft >= setWidth * 2) {
          this.isResetting = true;
          this.scroller.scrollLeft = scrollLeft - setWidth;
          this.isResetting = false;
          return;
        }

        if (scrollLeft <= 1) {
          this.isResetting = true;
          this.scroller.scrollLeft = scrollLeft + setWidth;
          this.isResetting = false;
        }
      }
    },
  );
}
